<template>
  <div>
  <v-snackbar
      v-model="showSnackbar"
      bottom
      multi-line
      :timeout="0"
    >
    {{ getMessage() }}
    <v-btn
        color="pink"
        flat
        @click="hideSnackbar()"
        data-test="hideButton"
      >
        OK
      </v-btn>
  </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'snackbar',

  computed: {
    ...mapState({
      showSnackbar: state => (state.snackbar.show)
    })
  },

  methods: {
    ...mapActions({
      hideSnackbar: 'snackbar/hideSnack'
    }),
    ...mapGetters({
      getMessage: 'snackbar/getMessage'
    })
  }
}
</script>
